import React from "react";
import "../../assets/css/roadmap.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import SocialBanner from "../../components/SocialBanner";
import {
	Roadmap1,
	Roadmap2,
	Roadmap3,
	Roadmap4,
	Roadmap5,
} from "../../constant/Index";
import { useSiteContentQuery } from "../../store/services/SitesettingService";
import { useRoadContentQuery } from "../../store/services/RoadMapService";

const RoadMap = () => {
	const { data, isLoading } = useSiteContentQuery();
	const { data: roadBox, isLoading: roadLoading } = useRoadContentQuery();
	let RoadData = data?.response?.data[0];
	let RoadBoxes = roadBox?.response?.data;
	return (
		<>
			{/* Header Sec Start Here */}
			<Header />
			{/* Header Sec End Here */}

			{/* <!-- Road Map Sec Start Here --> */}
			<section className="road_map roadmap_page">
				<div className="glowing glowing-one">
					<span></span>
				</div>
				<div className="container">
					<div className="heading_wrapper">
						<h4>ROAD MAP ACTIVATIONS </h4>
						{/* <h2>{}</h2> */}
						<h3>{RoadData?.roadmap_title}</h3>
						<p
							dangerouslySetInnerHTML={{
								__html: RoadData?.roadmap_description,
							}}
						></p>
					</div>
					<div className="row">
						{RoadBoxes?.map((data, index) => {
							return (
								<div className="col-lg-6" key={data?.id}>
									<div
										className={
											index % 2 === 0 ? "map_box map_left" : "map_box map_right"
										}
									>
										<div className="content">
											<h4>{data?.discount}</h4>
											<h5>{data?.title}</h5>
										</div>
										<div className="border-dv"></div>
										<div className="nft-img">
											<figure>
												<img
													src={data?.image_path}
													alt=""
													className="img-fluid"
												/>
											</figure>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
				<div className="glowing glowing-two">
					<span></span>
				</div>
			</section>
			{/* <!-- Road Map Sec End Here --> */}

			{/* Social Banner Sec Start Here */}
			<SocialBanner />
			{/* Social Banner Sec End Here */}

			{/* Footer Sec Start Here */}
			<Footer />
			{/* Footer Sec End Here */}
		</>
	);
};

export default RoadMap;
